import { FleetBusStatusCard, FleetBusTypesCard, FleetInfoCard, ReturnButton } from "_components";
import { DatasTableFleetBuses } from ".";
import { SettingsLayout } from "views/settings";
import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mapActions } from "_store";

export { DataFleet };

function DataFleet() {

    const { flotteId } = useParams();    
    const dispatch = useDispatch()
    const fleetData = useSelector(state => state.map.fleet)

    useEffect(() => {
        if (flotteId){
            dispatch(mapActions.getFleetInfo(flotteId))
        }
    }, [flotteId])

    const leftDivRef = useRef(null); // Référence à la div de gauche
    const [rightDivHeight, setRightDivHeight] = useState('auto'); // État pour la hauteur de la div de droite

    useEffect(() => {
        if (leftDivRef.current) {
            // Récupérer la hauteur de la div de gauche
            const height = leftDivRef.current.clientHeight;
            setRightDivHeight(height); // Mettre à jour la hauteur de la div de droite
        }
    }, [fleetData]); // Dépendance pour recalculer si fleetData change

    return (
        <div className="px-10 pb-10">
            <ReturnButton />
            <div className="flex mt-6 gap-4">
                <div ref={leftDivRef} className="flex flex-col w-2/5 gap-4" id="left-div">
                    <FleetInfoCard data={fleetData}/>
                    <FleetBusStatusCard data={fleetData?.vin}/>                    
                    <FleetBusTypesCard data={fleetData?.count_by_type}/>                       
                </div>
                <div className="flex-1" style={{ height: rightDivHeight }}>
                    <DatasTableFleetBuses fleet={fleetData?.vin} height={rightDivHeight}/>
                </div>
            </div>    
            <SettingsLayout />
        </div>
    );
}